import React from 'react'
import { Pagination, type PaginationProps } from '@enamelai/design-system'
import type { StaffWeek } from './staffShifts.util'

export type WorkScheduleDayColumn = {
  name: string
  date: string
  isToday: boolean
}

type WorkScheduleTableProps = {
  days: WorkScheduleDayColumn[]
  staffWeeks: StaffWeek[]
  pagination?: PaginationProps
}

const WorkScheduleTable: React.FC<WorkScheduleTableProps> = ({
  days,
  staffWeeks,
  pagination,
}) => (
  <div className="ws-table-block">
    <div className="ws-table-frame">
      <table className="ws-table" aria-label="Staff work schedule">
        <thead>
          <tr>
            <th scope="col" className="ws-th ws-th--staff">
              Staff members
            </th>
            {days.map((day) => (
              <th
                key={day.date}
                scope="col"
                className={`ws-th${day.isToday ? ' ws-th--today' : ''}`}
                aria-current={day.isToday ? 'date' : undefined}
              >
                <span className="ws-th-day">{day.name}</span>
                <span className="ws-th-date">{day.date}</span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {staffWeeks.map((staff) => (
            <tr key={staff.staffId || staff.staffName}>
              <th scope="row" className="ws-td ws-td--staff">
                {staff.staffName}
              </th>
              {staff.shifts.map((shift, index) => (
                <td
                  key={days[index]?.date ?? index}
                  className={`ws-td ws-td--${shift.kind}${
                    days[index]?.isToday ? ' ws-td--today' : ''
                  }`}
                >
                  {shift.label}
                  {shift.overrideLabel ? (
                    <span className="ws-td-override">
                      {shift.overrideLabel}
                    </span>
                  ) : null}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {pagination ? (
      <Pagination className="ws-pagination" {...pagination} />
    ) : null}
  </div>
)

export default WorkScheduleTable
